import { Component, Vue, Watch } from 'vue-property-decorator'
import HighFilter from '@/components/highFilter/index.vue'
import { queryTeacherAdminTA, editTAStatus } from '@/api'
@Component({ name: 'TeamList', components: { HighFilter } })
export default class TeamList extends Vue {
  private tableData: any = []
  private currentPage = 1
  private totalPage = 1
  private filterData: any = []
  private filterResult: any = {}
  private showHighFilter = false
  private fileList: any =[]
  private addObj: any = {
    name: '',
    sex: '',
    idcare: ''
  }

  private pageType: any = null

  created () {
    // this.pageType 1.ta团队 2.离职库
    this.pageType = this.$route.meta.type
    this.initPageData()
  }

  activated () {
    // 只刷新数据，不改变整体的缓存
    this.initPageData()
  }

  private async initPageData () {
    const param: any = { page: this.currentPage, limit: 20, status: 2 }
    if (this.filterResult) {
      param.search = this.filterResult
    }
    const result: any = await queryTeacherAdminTA(param)
    this.currentPage = result.currentPage
    this.totalPage = result.allPage
    this.tableData = result.teacherList
    this.filterData = result.search
  }

  // 分页查询
  private onPageChange (page: any) {
    this.currentPage = page
    this.initPageData()
  }

  // 筛选查询
  private async onFilterResult (data: any) {
    this.filterResult = data
    this.currentPage = 1
    await this.initPageData()
    this.showHighFilter = false
  }

  // 点击跳转详情页面
  rowClickTable (row: any) {
    this.$router.push({ path: '/TAteam/ta_team_detail', query: { id: row.id, type: this.pageType } })
  }

  private handleRemove (file: any, fileList: any) {
    console.log(file, fileList)
  }

  private handlePreview (file: any) {
    console.log(file)
  }

  private handleExceed (files: string | any[], fileList: string | any[]) {
    this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
  }

  private beforeRemove (file: { name: any }) {
    return this.$confirm(`确定移除 ${file.name}？`)
  }

  private async editStatus (row: any) {
    this.$confirm('确认将该TA激活?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      center: true
    }).then(async () => {
      const { error }: any = await editTAStatus({ id: row.id, status: 1 })
      if (!error) {
        this.$message({ message: '激活成功', type: 'success' })
        this.initPageData()
      }
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消删除'
      })
    })
  }
}
